import api from "src/api/axiosInstance";

export const addToCartApi = async (product, quantity, variantId, slotId) => {
  try {
    let payload = {
      productId: product.ID,
      quantity: quantity,
    };
    if (variantId) {
      payload = {
        productId: product.ID,
        quantity: quantity,
        variantId: variantId,
      };
    }
    if (slotId) {
      payload = {
        productId: product.ID,
        quantity: quantity,
        slotId: slotId,
      };
    }
    
    // Add variantName if it exists in the product
    if (product.variantName) {
      payload.variantName = product.variantName;
    }
    
    const result = await api.post(`/cart`, JSON.stringify(payload));
    return result;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};

export const getCartProductsApi = async () => {
  try {
    const result = await api.get(`/cart`);
    if (result?.data) return result.data;
    return [];
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};

export const deleteFromCartApi = async (cartItemId) => {
  try {
    const result = await api.delete(`/cart/${cartItemId}`);
    return result;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};
